import { render, staticRenderFns } from "./Branches.vue?vue&type=template&id=0f445ff2"
import script from "./Branches.vue?vue&type=script&lang=js"
export * from "./Branches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports